"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiDimentionalWeakMap = void 0;

require("weakmap-polyfill");

var Which = WeakMap;

var MultiDimentionalWeakMap =
/** @class */
function () {
  function MultiDimentionalWeakMap(length) {
    this.length = length;
    this.weakMap = new Which();
    this.weakMap = new Which();
  }

  MultiDimentionalWeakMap.prototype.get = function (keys) {
    var e_1, _a;

    if (keys.length !== this.length) {
      throw new Error("incorrect number of keys passed");
    }

    var last = this.weakMap;

    try {
      for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
        var key = keys_1_1.value;
        last = last.get(key);
        if (!last || !(last instanceof Which)) break;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return last;
  };

  MultiDimentionalWeakMap.prototype.set = function (keys, value) {
    if (keys.length !== this.length) {
      throw new Error("incorrect number of keys passed");
    }

    var last = this.weakMap;

    for (var i = 0; i < keys.length - 1; i++) {
      var key = keys[i];
      var val = last.get(key);

      if (!val) {
        val = new Which();
        last.set(key, val);
      }

      last = val;
    }

    var lastKey = keys[keys.length - 1];
    last.set(lastKey, value);
  };

  return MultiDimentionalWeakMap;
}();

exports.MultiDimentionalWeakMap = MultiDimentionalWeakMap;